import { useTranslation } from "react-i18next";

export const useToastMessages = () => {
  const { t } = useTranslation();

  return {
    sending: () => t("sending") || "Sende...",
    saving: () => t("saving") || "Speichere...",
    error: () => t("error") || "Fehler aufgetreten",
    success: () => t("success") || "Erfolgreich",
    sendFailed: () => t("sendFailed") || "Senden fehlgeschlagen",
    contactThanks24h: () =>
      t("contactThanks24h") ||
      "Vielen Dank! Wir melden uns innerhalb von 24 Stunden.",
    sendError: () => t("sendError") || "Fehler beim Senden",
  };
};
